import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/parts')({
  component: () => <RouteGuard route="/parts" />,
});
